import { initReactI18next } from 'react-i18next'

import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { getInitialNamespaces } from 'remix-i18next/client'

import i18n from '@/shared/config/i18n'
import { initFormatters } from '@/shared/lib/formatter'

export const initI18next = async () => {
	await i18next
		.use(initReactI18next)
		.use(LanguageDetector)
		.use(Backend)
		.init({
			...i18n,
			ns: getInitialNamespaces(),
			backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
			detection: {
				order: ['htmlTag'],
				caches: []
			}
		})

	initFormatters(i18next)

	return i18next
}
